import React from 'react';

function VisionModeBadge({ mode, size = 'md' }) {
  const configs = {
    vision: {
      label: 'Vision',
      className: 'mode-badge mode-vision'
    },
    text: {
      label: 'Text',
      className: 'mode-badge mode-text'
    },
    hybrid: {
      label: 'Hybrid',
      className: 'mode-badge mode-vision' // Use vision style for hybrid
    }
  };

  const config = configs[mode] || configs.text;

  // Icon for vision mode
  const VisionIcon = () => (
    <svg className="w-2.5 h-2.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  // Icon for text mode
  const TextIcon = () => (
    <svg className="w-2.5 h-2.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  );

  return (
    <span className={config.className}>
      {mode === 'vision' || mode === 'hybrid' ? <VisionIcon /> : <TextIcon />}
      {config.label}
    </span>
  );
}

export default VisionModeBadge;
